import {Component} from "react";
import {Alert} from "react-bootstrap";

export default class ErrorBoundary extends Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            error: null,
            hasError: false
        };
    }

    static getDerivedStateFromError(error: any) {
        return {error, hasError: true};
    }

    render() {
        const {error, hasError} = this.state;
        if (hasError)
            return <Alert variant="sesc-red" className="shadow-sm mx-auto text-center">
                <h1>Algo deu errado.</h1>
                <p className="mb-0">{error?.message || error || 'Erro inesperado.'}</p>
            </Alert>;
        return this.props.children;
    }

}